import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import React, { useState } from 'react'
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useNavigate } from 'react-router-dom';

function ExpandedSideOption({ item , collapsed}) {

    let navigate = useNavigate();

    const [expanded, setExpanded] = useState(false);

    const handleToggleSettings = () => {
        setExpanded(!expanded); // Toggle the expanded state of "Settings"
    };

    return (
        <div>
            <ListItem
                onClick={handleToggleSettings}
                button
                sx={{ py: 1, paddingRight:"0px", cursor:"pointer", minWidth: "40px" }}
            >
                {item.icon && (
                    <ListItemIcon sx={{ minWidth: "35px" }}>
                        {item.icon}
                    </ListItemIcon>
                )}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "space-between",
                        paddingRight:"0px"
                    }}
                >
                    {!collapsed && (
                        <ListItemText primary={item.title} />
                    )}
                    <ListItemIcon sx={{ minWidth: "35px" }}>
                        {/* Display Chevron icon depending on the state */}
                        {expanded ? (
                            <ArrowDropDownIcon />
                        ) : (
                            <ArrowDropUpIcon />
                        )}
                    </ListItemIcon>
                </Box>
            </ListItem>

            {/* If expanded, render the children options */}
            {expanded && (
                <List sx={{ pl: 4 }}>
                    {item.children.map((child, idx) => (
                        <ListItem
                            onClick={() => navigate(child.route)}
                            button
                            key={idx}
                            sx={{ py: 1, minWidth: "40px", cursor:"pointer" }}
                        >
                            {child.icon && (
                                <ListItemIcon sx={{ minWidth: "35px" }}>
                                    {child.icon}
                                </ListItemIcon>
                            )}
                            {!collapsed && (
                                <ListItemText primary={child.title} />
                            )}
                        </ListItem>
                    ))}
                </List>
            )}
        </div>
    )
}

export default ExpandedSideOption